import React from 'react'
import Legacy from './Legacy'

const ProductUnavailable = (props) => {
  return <Legacy {...props}/>
}

export default ProductUnavailable
